export default __webpack_public_path__ + "static/media/Yoga.659e8d0f.jpg";